import React, { useContext, useEffect, useRef, useState } from 'react';
import './UpdateProductRus.css';
import search from '../../img/search.svg';
import { Contexts } from '../../context/Contexts';
import { useUpdateProductRusMutation } from '../../redux/ProductRusApi';

export default function UpdateProductRus() {
    const { RusData, errorRus, isLoadingRus, isSuccessRus } = useContext(Contexts);
    const [UpdateProductRus, result] = useUpdateProductRusMutation();

    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [maxSlice, setMaxSlice] = useState(3);
    const [clicked, setClicked] = useState(false);
    const [productId, setProductId] = useState(null);
    const [formData, setFormData] = useState({
        modelName: '',
        brandName: '',
        description: '',
        guaranteePeriod: '',
        madeIn: '',
        produced: '',
        paymentType: '',
        extraDevices: '',
        paymentContract: false,
        service: false,
    });
    const [noInfo, setNoInfo] = useState('Пожалуйста, введите название модели.');
    const [dataInfo, setDataInfo] = useState('');
    const [error, setError] = useState('');

    const inputRef = useRef(null);

    useEffect(() => {
        setTimeout(() => {
            inputRef.current.focus();
        }, 0);
    }, []);

    const handleSearch = (query) => {
        setSearchQuery(query);
        if (query.trim() === '') {
            setSearchResults([]);
            setClicked(false);
            setNoInfo('Пожалуйста, введите название модели.');
            return;
        }
        setNoInfo('Информация не найдена.');
        const results = isSuccessRus ? RusData.filter(product =>
            product.modelName.toLowerCase().includes(query.toLowerCase())
        ) : [];
        setSearchResults(results);
        setClicked(false);
        setMaxSlice(3);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setMaxSlice(prevMaxSlice => prevMaxSlice + 3);
    };

    const handleClick = (id) => {
        setClicked(true);
        setProductId(id);
        setDataInfo('');
        const product = RusData.find(product => product.id === id);
        setFormData({
            modelName: product.modelName || '',
            brandName: product.brandName || '',
            description: product.description || '',
            guaranteePeriod: product.guaranteePeriod || '',
            madeIn: product.madeIn || '',
            produced: product.produced || '',
            paymentType: product.paymentType || '',
            extraDevices: product.extraDevices || '',
            paymentContract: product.paymentContract || false,
            service: product.service || false,
        });
    };

    const handleUpdateProductRus = async (e) => {
        e.preventDefault();
        setError('');

        const requiredFields = ['modelName', 'brandName', 'description', 'guaranteePeriod', 'madeIn', 'produced', 'paymentType', 'extraDevices'];
        const emptyFields = requiredFields.filter(field => !formData[field]);

        if (emptyFields.length > 0) {
            setError('Пожалуйста, заполните все обязательные поля.');
            return;
        }

        await UpdateProductRus({ id: productId, ...formData });
        setDataInfo('');
    };

    useEffect(() => {
        if (result.isLoading) {
            setDataInfo('Загрузка данных.');
        } else if (result.isSuccess) {
            setFormData({
                modelName: '',
                brandName: '',
                description: '',
                guaranteePeriod: '',
                madeIn: '',
                produced: '',
                paymentType: '',
                extraDevices: '',
                paymentContract: false,
                service: false,
            });
            setDataInfo('Данные загружены.');
            setClicked(false);
        } else if (result.isError) {
            setDataInfo('Ошибка, попробуйте еще раз.');
        }
    }, [result]);

    const labels = {
        modelName: 'Название модели',
        brandName: 'Бренд',
        description: 'Описание',
        guaranteePeriod: 'Гарантийный срок',
        madeIn: 'Сделано в',
        produced: 'Произведено',
        paymentType: 'Тип оплаты',
        extraDevices: 'Дополнительные устройства',
        paymentContract: 'Платежный договор',
        service: 'Сервис',
    };

    return (
        <div className='updateProductRus'>
            <div className="top">
                <form onSubmit={handleSubmit}>
                    <input
                        ref={inputRef}
                        placeholder='Search'
                        type="text"
                        value={searchQuery}
                        onChange={(e) => handleSearch(e.target.value)}
                    />
                    <button type='submit'>
                        <img src={search} alt="search" />
                    </button>
                </form>
            </div>
            <div className='bottom flex'>
                {isSuccessRus && !clicked ? (
                    <>
                        {searchResults.slice(0, maxSlice).map(product => (
                            <div
                                onClick={() => handleClick(product.id)}
                                className='box flex'
                                key={product.id}
                            >
                                <div className="img">
                                    <img src={product.filePath} alt={product.modelName} />
                                </div>
                                <div className="text">
                                    <h3>{product.modelName.length > 80 ? `${product.modelName.slice(0, 80)}...` : product.modelName}</h3>
                                    <p>{product.brandName}</p>
                                </div>
                            </div>
                        ))}
                        {searchResults.length > maxSlice && (
                            <button onClick={handleSubmit}>Ещё</button>
                        )}
                        {!searchResults.length && <h4 className='noInfo'>{noInfo}</h4>}
                    </>
                ) : (
                    <div className="formBox">
                        <form onSubmit={handleUpdateProductRus}>
                            {Object.entries(formData).map(([key, value]) => (
                                key === 'paymentContract' || key === 'service' ? (
                                    <div className="formGroup flex checkbox-wrapper" key={key}>
                                        <label htmlFor={key}>{labels[key]}</label>
                                        <label className="rocker rocker-small">
                                            <input
                                                type="checkbox"
                                                id={key}
                                                checked={value}
                                                onChange={(e) => setFormData({ ...formData, [key]: e.target.checked })}
                                                className={`checkbox-${key}`}
                                            />
                                            <span className="switch-left">Да</span>
                                            <span className="switch-right">Нет</span>
                                        </label>
                                    </div>
                                ) : key === 'description' ? (
                                    <div className="formGroup flex" key={key}>
                                        <label htmlFor={key}>{key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}</label>
                                        <textarea
                                            placeholder='Пожалуйста, пишите на русском языке.'
                                            id={key}
                                            value={value}
                                            onChange={(e) => setFormData({ ...formData, [key]: e.target.value })}
                                        />
                                    </div>
                                ) : (
                                    <div className="formGroup flex" key={key}>
                                        <label htmlFor={key}>{labels[key]}</label>
                                        <input
                                            placeholder='Пожалуйста, пишите на русском языке.'
                                            type="text"
                                            id={key}
                                            value={value}
                                            onChange={(e) => setFormData({ ...formData, [key]: e.target.value })}
                                        />
                                    </div>
                                )
                            ))}
                            {error && <h4 className='error'>{error}</h4>}
                            <h4 className='dataInfo'>{dataInfo}</h4>
                            <button type='submit'>Обновить</button>
                        </form>
                    </div>
                )}
                {isLoadingRus && <h4 className='noInfo'>Загрузка, пожалуйста подождите.</h4>}
                {errorRus && <h4 className='noInfo'>Ошибка, попробуйте еще раз.</h4>}
            </div>
        </div>
    );
}